import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'formly-horizontal-wrapper',
  templateUrl: './formly-horizontal-wrapper.html',
  styleUrls: ['formly-horizontal-wrapper.scss']
})
// tslint:disable-next-line: component-class-suffix
export class FormlyHorizontalWrapper extends FieldWrapper {
}
